import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { IOrderInitialState } from "./types";
import initialState from "./state";


const setCollapse: CaseReducer<IOrderInitialState, PayloadAction<IOrderInitialState['collapse']>> = (state, action) => {
  state.collapse = action.payload;
};

const setSelectedOrder: CaseReducer<IOrderInitialState, PayloadAction<IOrderInitialState['selectedOrder']>> = (state, action) => {
  state.selectedOrder = action.payload;
};

const setOrderFormData: CaseReducer<IOrderInitialState, PayloadAction<IOrderInitialState['orderFormData']>> = (state, action) => {
  state.orderFormData = action.payload;
};

const setAssignedDrone: CaseReducer<IOrderInitialState, PayloadAction<IOrderInitialState['assignedDrone']>> = (state, action) => {
  state.assignedDrone = action.payload;
};

const setAssignMethod: CaseReducer<IOrderInitialState, PayloadAction<IOrderInitialState['assignMethod']>> = (state, action) => {
  state.assignMethod = action.payload;
};

const setMissionId: CaseReducer<IOrderInitialState, PayloadAction<IOrderInitialState['missionId']>> = (state, action) => {
  state.missionId = action.payload;
};

const setSelectedMissionTemplate: CaseReducer<IOrderInitialState, PayloadAction<IOrderInitialState['selectedMissionTemplate']>> = (state, action) => {
  state.selectedMissionTemplate = action.payload;
};

export default { setCollapse, setSelectedOrder, setOrderFormData, setAssignedDrone, setAssignMethod, setMissionId, setSelectedMissionTemplate };